// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"c689aef9","711":"c689aef9"}[chunkId] + ".chunk.css";
};